<template>
	<div class="LP-container disp-scroll">
    <LPTopHeader/>
    <KeyVisual/>
    <KeyMessage/>
    <Issues/>
    <Features/>
    <Functions/>
    <RecommendTrial/>
		<Effects/>
    <CaseStudies/>
		<ImplementationSteps/>
		<RecommendTrial/>
    <Questions/>
		<LPFooter/>
		<input type="hidden" id="ndrkey" name="ndrkey" value="0837d9e449a8ab6c602a4316deb5fd12">
	</div>
</template>

<script>
import LPTopHeader from '@/views/LP/LPTopHeader'
import KeyVisual from '@/views/LP/KeyVisual'
import KeyMessage from '@/views/LP/KeyMessage'
import Issues from '@/views/LP/Issues'
import Features from '@/views/LP/Features'
import Functions from '@/views/LP/Functions'
import Effects from '@/views/LP/Effects'
import RecommendTrial from '@/views/LP/RecommendTrial'
import CaseStudies from '@/views/LP/CaseStudies'
import ImplementationSteps from '@/views/LP/ImplementationSteps'
import Questions from '@/views/LP/Questions'
import LPFooter from '@/views/LP/LPFooter'

export default {
	name: 'LP',
	components: {
		LPTopHeader,
		KeyVisual,
		KeyMessage,
		Issues,
		Features,
		Functions,
		Effects,
		RecommendTrial,
		CaseStudies,
		ImplementationSteps,
		Questions,
		LPFooter
	},
	created () {
		this.displayIcon()
	},
	methods: {
		displayIcon () {
			var script=document.createElement("script")
			script.async = true
			script.src = process.env.WDT_ENDPOINT + "/wdt/widget.js?2021329"
			var entry=document.getElementsByTagName("script")[0]
			entry.parentNode.insertBefore(script,entry)
		}
	}
}
</script>

<style lang="scss" scoped>
.LP-container {
	height: 100vh;
	text-align: left;
	font-family: 'Noto Sans Japanese',   sans-serif;
	background-color: #fefefe;
	color: #333333;
	position: relative;
	overflow-y: scroll;
}

// deep selector
$h2-font-size: 38px;

.LP-container /deep/ h1 {
  font-size: 54px;
	font-weight: 900;
}
.LP-container /deep/ h2 {
	font-size: $h2-font-size;
	font-weight: bold;
}
.LP-container /deep/ h3 {
	font-size: 24px;
	font-weight: bold;
}
.LP-container /deep/ h4 {
	font-size: 20px;
	font-weight: bold;
}
.LP-container /deep/ .emphasis {
	color: #C4283A;
	font-size: $h2-font-size;
	font-weight: bold;
}
.LP-container /deep/ img {
	vertical-align: bottom;
}
.LP-container /deep/ *:focus {
  outline: none;
}
.LP-container /deep/ .main-section {
	position: relative;
}
.LP-container /deep/ .link-point {
	position: absolute;
	top: -80px;
}
@media screen and (max-width: 1194px) {
	.LP-container /deep/ h1 {
		font-size: 44px;
	}
}
@media screen and (max-width: 1024px) {
	.LP-container /deep/ h1 {
		font-size: 40px;
	}
}
@media screen and (max-width: 950px) {
	.LP-container /deep/ h1 {
		font-size: 58px;
	}
}
@media screen and (max-width: 896px) {
	.LP-container /deep/ h1 {
		font-size: 40px;
	}

	$h2-font-size: 26px;

	.LP-container /deep/ h2 {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ .emphasis {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ h3 {
		font-size: 18px;
		font-weight: bold;
	}
.LP-container /deep/ h4 {
	font-size: 16px;
	font-weight: bold;
}
	.LP-container /deep/ .link-point {
		top: -40px;
	}
}
@media screen and (max-width: 480px) {
	.LP-container /deep/ * {
		font-size: 16px;
	}
	.LP-container /deep/ h1 {
		font-size: 28px;
		font-weight: 900;
	}

	$h2-font-size: 22px;

	.LP-container /deep/ h2 {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ .emphasis {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ h3 {
		font-size: 18px;
		font-weight: bold;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/LP.vue